import { useTranslation } from 'react-i18next';
import { fallbackLocale, Locales } from 'shared/assets/localization';

export const useI18nLocale = () => {
  const { i18n } = useTranslation();
  return (i18n.resolvedLanguage as Locales) ?? fallbackLocale;
};
